var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogininfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a {\n                fill: #fff;\n                stroke: #333333;\n                stroke-width: 0.7px;\n            }\n\n            .b {\n                fill: #333333;\n            }\n\n            .c {\n                stroke: none;\n            }\n\n            .d {\n                fill: none;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-226 -320)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(226 320)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 14,
    height: 22,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.35,
    y: 0.35,
    width: 13.3,
    height: 21.3,
    rx: 3.65
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(232 325)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(0 5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1,
    cy: 1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(0 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogininfo);
export default __webpack_public_path__ + "static/media/logininfo.147b9145cb1001b53cf3a6e8ce1262ef.svg";
export { ForwardRef as ReactComponent };